module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.heights)
  }, [(!_vm._loading) ? _c('div', [_vm._t("default")], 2) : _c('div', {
    staticClass: "container"
  }, [_vm._t("spin", function() {
    return [_c('Spin', {
      attrs: {
        "fix": ""
      }
    }, [_c('Icon', {
      staticClass: "demo-spin-icon-load",
      attrs: {
        "type": "ios-loading",
        "size": "40"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "60px"
      }
    }, [_vm._v("加载中")])], 1)]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfb63a5c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 666
// module chunks = 120